import { gql } from '@apollo/client';

// IB-1899 Reporting requirements
export const REPORTING_PERIOD_ITEM = gql`
  fragment reportingPeriodItem on ReportingPeriodItem {
    id
    periodNumber
    label
    periodStart
    periodEnd
    opensOn
    dueOn
    status
    statusLabel
    outsideSchedule
    waived
    waivedReason
    waivedByName
    waivedAt
    recordId
    recordCount
  }
`;

export const REPORTING_REPORTER_ITEM = gql`
  fragment reportingReporterItem on ReportingRequirementReporterItem {
    id
    organisationId
    organisationName
    siteIds
    overrideStartDate
    overrideEndDate
    overrideDueOffsetDays
    effectiveStartDate
    effectiveEndDate
    effectiveDueOffsetDays
    startDateOverridden
    endDateOverridden
    dueOffsetOverridden
  }
`;

export const REPORTING_REQUIREMENT_DETAIL = gql`
  fragment reportingRequirementDetail on ReportingRequirementDetail {
    id
    name
    status
    itemType
    itemId
    itemName
    associationType
    associationId
    associationName
    frequency
    frequencyLabel
    frequencyLocked
    startDate
    endDate
    fixedDueDate
    dueOffsetDays
    openOffsetDays
    submissionsPerPeriod
    hasReviewStep
    updatedAt
    reporters {
      ...reportingReporterItem
      periods {
        ...reportingPeriodItem
      }
    }
  }
  ${REPORTING_REPORTER_ITEM}
  ${REPORTING_PERIOD_ITEM}
`;
